import { AI_CONVERSATIONS_REDUCER_KEY } from './aiConversationsReducer';

const getStore = (state) => state[AI_CONVERSATIONS_REDUCER_KEY];
export const getAiConversations = (state) => getStore(state)?.history;

export const getIsLoading = (state) => getStore(state).isLoading;
